import { BlogPost } from "../../../services/blog-service";
import { blogButton, FreeContent } from "./free-content-utils";
import SubCard from "./sub-card";

type FreeContentCardProps = {
  content: FreeContent;
  blog: Array<BlogPost>;
};

export default function FreeContentCard({
  content,
  blog,
}: FreeContentCardProps) {
  const { title, description, link, tag, image, buttonTitle } = content;

  return (
    <>
      {tag === "blog" ? (
        <>
          {blog.map((item, index) => (
            <SubCard
              key={index}
              description={item.description}
              image={`url(${item.image}) center`}
              link={`https://kenzie.com.br/blog/${item.slug}/`}
              title={item.title}
              typeCard="BLOG | "
              buttonTitle={blogButton}
              tag={tag}
            />
          ))}
        </>
      ) : (
        <SubCard
          description={description}
          image={image}
          link={link}
          title={title}
          buttonTitle={buttonTitle}
          tag={tag}
        />
      )}
    </>
  );
}
